import React from 'react';
import { IconSource, Link } from '@clariness/clarikit-react';
import { NavBarItemLabel } from '../NavBarItemLabel/NavBarItemLabel';

type NavBarActionLinkProps = {
  url: string;
  icon: IconSource;
  label: string;
  onClick: () => void;
};

export const NavBarActionLink: React.FC<NavBarActionLinkProps> = ({
  url,
  icon,
  label,
  onClick,
}) => {
  return (
    <Link
      url={url}
      color="color-gray-variant-1"
      aria-label={label}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onClick();
      }}
    >
      <NavBarItemLabel icon={icon} color="color-gray-variant-1" label={label} />
    </Link>
  );
};
